<div class="container">
  <mat-tab-group #tabGroup mat-stretch-tabs mat-align-tabs="center">
    <mat-tab [label]="'generic.details' | translate">
      <div class="mt-5">
        <app-survey-details
          *ngIf="survey_id"
          [surveyId]="survey_id"
          (canceled)="backToProject($event)"
          (surveyChanged)="onSurveyChanged($event)"
          [noButtons]="noButtons"
        />
      </div>
    </mat-tab>
    <mat-tab *ngIf="survey && !survey?.is_draft">
      <ng-template mat-tab-label>
        <span>{{ 'components.responses.responses' | translate }}</span>
        <mat-icon
          *ngIf="survey?.status == 'EVALUATING'"
          [ngStyle]="{'color': '#f44336'}"
          class="ml-2">notifications
        </mat-icon>
      </ng-template>

      <app-survey-all-responses
        [surveyId]="survey_id"
        [survey]="survey"
        #allResponsesComponent>
      </app-survey-all-responses>
    </mat-tab>
    <mat-tab [label]="'generic.team' | translate" *ngIf="survey?.visibility_type === 'PRIVATE' && !survey?.is_draft">
      <div class="mt-5">
        <app-survey-team [members]="survey?.members" [surveyId]="survey_id" [surveyIsClosed]="survey?.status == 'CLOSED'"/>
      </div>
    </mat-tab>
    <mat-tab [label]="'modals.modal-survey-details.revisions-management' | translate"
             *ngIf="survey && consensusQuestionsExist && survey?.answers_sent > 0">
      <div class="mt-5">
        <app-survey-dashboard *ngIf="survey" [survey]="survey"/>
      </div>
    </mat-tab>
    <mat-tab [label]="'modals.modal-survey-details.survey-tree' | translate"
             *ngIf="survey && survey?.history_surveys_count > 1">
      <div class="mt-5">
        <app-survey-tree [survey]="survey" (surveyNodeClicked)="surveyNodeCLicked($event)"/>
      </div>
    </mat-tab>
    <mat-tab [label]="'generic.questions-dashboard' | translate" *ngIf="survey && consensusQuestionsExist">
      <div class="mt-5">
        <app-survey-questions-dashboard [survey]="survey"/>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
